import { makeAutoObservable } from 'mobx'
import { productSaleMobx, restaurantConfig, discountMobx, restaurantCenter, RESTAURANT_EVENT } from '..'
import { toDecimal } from '@dt/fe-utils'
import { defaultConfig } from './center/cookware'
import { keyBy, cloneDeep, flattenDeep, map } from '@dt/fe-utils/dist/lodash'

class Product {
  constructor () {
    makeAutoObservable(this)
  }
  /** 餐品默认图 */
  defaultPic = defaultConfig.defaultCover

  /** 餐品默认图 暗黑 */
  defaultPicDark = defaultConfig.defaultCoverDark

  /** 初始化标记 */
  isInited = false

  /** 默认渠道 */
  channel: TChannel = 'pos'

  /** 餐品数据 */
  products: IProduct[] = []

  /** 分类数据 */
  categories: ICategory[] = []

  /** 计算后的餐品数据集合, 能获取到餐品的售卖状态 显示情况等 */
  get viewProducts (): IViewProduct[] {
    const productNoToCntMap = productSaleMobx.menuProductNoToCntMap
    const scaleNoToCntMap = productSaleMobx.scaleNoToCntMap
    // 这个是规格ID级的售卖数量，-1 0 > 0 ,所有的规格都有这样的对应关系
    const productIdToIsCanTogo: any = {}
    let viewProductsMap: any = {} // 单品的map
    let sortMap: any = {} // 原始排序
    let comps: IViewProduct[] = [] // 套餐的数组
    let products: IViewProduct[] = [] // 单品的数组
    this.products.forEach((product, index: number) => {
      sortMap[product.no] = index
      const scales: IScale[] = []
      // 餐品时价
      const isOpenPrice = product.scaleGroup.scales?.every(scale => scale.isOpenPrice)
      // 当前的判断逻辑 显示最低价
      let isScaleOpenPrice = false
      let minPrice = 999999
      let theScaleNo = '0'
      product.scaleGroup.scales.forEach((scale) => {
        const vscale = cloneDeep(scale)
        /** 规格项不可单卖 */
        const isDisable = scale.status === 'disable'
        if (scaleNoToCntMap[product.no + '_' + scale.no]) {
          vscale.saleCnt = scaleNoToCntMap[product.no + '_' + scale.no].cnt
          vscale.saleTotalCnt = scaleNoToCntMap[product.no + '_' + scale.no].totalCnt
        }
        scales.push(vscale)
        if (scale.isOpenPrice) {
          isScaleOpenPrice = true
        } else if (typeof scale.price !== 'undefined') {
          if (!isDisable && scale.price <= minPrice) {
            minPrice = scale.price
            theScaleNo = scale.no
          }
        }
      })
      if (isOpenPrice) {
        minPrice = -1
      }
      let offPrice = 0
      let actualPrice = minPrice
      let memberPrice = -1
      let isMemberDiscount = false
      if (discountMobx.itemDiscountMap && discountMobx.itemDiscountMap[product.no + '_' + theScaleNo]) {
        const offItem = discountMobx.itemDiscountMap[product.no + '_' + theScaleNo]
        offPrice = offItem.off
        actualPrice = toDecimal(minPrice - offPrice) as number
        isMemberDiscount = offItem.offType === 'memberPrice'
        // 如果该餐品享受了会员优惠则不用再显示会员价
        if (!isMemberDiscount) {
          memberPrice = offPrice > 0 ? -1 : (offItem.memberPrice || -1)
        }
      }
      // 计算餐品的togo map
      productIdToIsCanTogo[product.id] = product.isCanTogo
      // 处理图片
      let pic = product.pic
      let picBig
      let picSmall
      let hasPic = false
      let picWidth
      let picHeight
      if (product.pic) {
        if (['kiosk', 'mobile'].includes(restaurantConfig.app)) {
          const defaultPicArr = JSON.parse(product.pics || '[]').filter((product: any) => product.default !== 0)
          const defaultPic = defaultPicArr.length ? defaultPicArr[0] : JSON.parse(product.pics || '[]')?.[0]
          // picWidth = product.picWidth
          // picHeight = product.picHeight
          picWidth = defaultPic?.w
          picHeight = defaultPic?.h
          if (defaultPic?.url && defaultPic?.type !== 'video') {
            pic = defaultPic?.url
          }
          const pics = pic?.split('.') || []
          // not support yet
          const base = pics[pics.length - 2]
          const suffix = pics[pics.length - 1]
          // gif 没有缩略图
          if (['jpg', 'png', 'jpeg'].includes(suffix)) {
            pics[pics.length - 2] = base + '_640'
            pic = pics.join('.')
            pics[pics.length - 2] = base + '_1280'
            picBig = pics.join('.')
            pics[pics.length - 2] = base + '_320'
            picSmall = pics.join('.')
          } else {
            picBig = picSmall = pic
          }
          hasPic = true
        } else {
          const pics = product.pic.split('.')
          // not support yet
          const base = pics[pics.length - 2]
          pics[pics.length - 2] = base + '_640'
          pic = pics.join('.')
          pics[pics.length - 2] = base + '_1280'
          picBig = pics.join('.')
          pics[pics.length - 2] = base + '_320'
          picSmall = pics.join('.')
          hasPic = true
          const defaultProductArr = JSON.parse(product.pics || '[]').filter((product: any) => product.default !== 0)
          const defaultProduct = defaultProductArr.length ? defaultProductArr[0] : JSON.parse(product.pics || '[]')?.[0]
          // picWidth = product.picWidth
          // picHeight = product.picHeight
          picWidth = restaurantConfig.app === 'pos' ? product.picWidth : defaultProduct.w
          picHeight = restaurantConfig.app === 'pos' ? product.picHeight : defaultProduct.h
        }
      } else {
        // pic = this.defaultPic
        // picBig = product.pic
      }
      let viewProduct: any = {
        ...product,
        scales,
        price: minPrice,
        isCombo: false,
        disable: false,
        isOpenPrice,
        isScaleOpenPrice,
        // scaleNo: theScaleNo,
        offPrice,
        isMemberDiscount,
        actualPrice,
        memberPrice,
        hasPic,
        pic,
        picBig,
        picSmall,
        picWidth,
        picHeight,
      }
      if (viewProduct.type === 'product') {
        viewProductsMap[viewProduct.no] = viewProduct
        const productSaleCnt = productNoToCntMap[viewProduct.no] ? productNoToCntMap[viewProduct.no].cnt : undefined
        const productSaleTotalCnt = productNoToCntMap[viewProduct.no] ? productNoToCntMap[viewProduct.no].totalCnt : undefined
        const disable = productSaleCnt === 0 || !product.isNotSingleInCombo
        viewProduct.disable = disable
        viewProduct.productGroups = undefined
        if (productSaleCnt !== undefined) {
          viewProduct.saleCnt = productSaleCnt
          viewProduct.saleTotalCnt = productSaleTotalCnt
        }
        products.push(viewProduct)
      }
      if (viewProduct.type === 'FixedCombo' || viewProduct.type === 'OptionalCombo') {
        comps.push(viewProduct)
      }
      return viewProduct
    })

    // 餐品
    // const viewProducts = allProducts.filter(product => product.type === 'product').map(product => {
    //   // 餐品可售份数
    //   const productSaleCnt = productNoToCntMap[product.no] ? productNoToCntMap[product.no].cnt : undefined
    //   const productSaleTotalCnt = productNoToCntMap[product.no] ? productNoToCntMap[product.no].totalCnt : undefined
    //   const disable = productSaleCnt === 0 || !product.isNotSingleInCombo
    //   const viewProduct: IViewProduct = {
    //     ...product,
    //     disable,
    //     productGroups: undefined
    //   }
    //   if (productSaleCnt !== undefined) {
    //     viewProduct.saleCnt = productSaleCnt
    //     viewProduct.saleTotalCnt = productSaleTotalCnt
    //   }
    //   return viewProduct
    // })

    // 套餐
    // const viewCombos = allProducts.filter(product => product.type === 'FixedCombo' || product.type === 'OptionalCombo').map(product => {
    for (let product of comps) {
      // const viewProductsMap = keyBy(viewProducts, 'no')
      // 餐品可售份数
      const productSaleCnt = productNoToCntMap[product.no] ? productNoToCntMap[product.no].cnt : undefined
      const productSaleTotalCnt = productNoToCntMap[product.no] ? productNoToCntMap[product.no].totalCnt : undefined
      // 只在pos端售卖，所以非app是tabletop的都不可卖
      const disable = productSaleCnt === 0 || !product.isNotSingleInCombo
      // 套餐组
      const productGroups = product.productGroups?.map((group) => {
        let viewGroup = { ...group }
        viewGroup.productGroupDetails = group.productGroupDetails.slice().sort((a, b) => (a?.sort?.toString() && b.sort?.toString()) ? (a.sort - b.sort) : 1).filter(i => viewProductsMap[i.productNo]).map(item => {
          let viewProduct = {}
          const _product: IViewProduct = cloneDeep({ ...item, ...viewProductsMap[item.productNo] })
          const _scales = _product?.scales?.filter(scale => scale.no === item.scaleNo)
          _product.disable = false
          _product.memberPrice = -1
          _product.isMemberDiscount = false
          if (_scales[0]) {
            if (_scales[0].saleCnt !== undefined) {
              _product.saleCnt = _scales[0].saleCnt
              _product.saleTotalCnt = _scales[0].saleTotalCnt
            }
            const price: number = item.productPrice as number
            _product.price = price
            _product.actualPrice = price
            _product.offPrice = 0
            _scales[0].actualPrice = price
            _scales[0].discountPrice = 0
          }
          _product.sort = item.sort
          viewProduct = { ..._product, scales: _scales }
          return viewProduct as IViewComboGroupProduct
        })
        return viewGroup as IViewComboGroup
      }) as IViewComboGroup[]
      // const viewProduct: IViewProduct = {
      //   ...product,
      //   disable,
      //   isCombo: true,
      //   productGroups
      // }
      product.disable = disable
      product.isCombo = true
      product.productGroups = productGroups
      if (product.type === 'FixedCombo') {
        product.isCanTogo = !!productGroups?.every(group => group.productGroupDetails.every(product => !!product.isCanTogo))
      } else if (product.type === 'OptionalCombo') {
        product.isCanTogo = !!productGroups?.every(group => group.productGroupDetails.every(product => !product.isDefault || (product.isDefault && !!product.isCanTogo)))
      }
      if (productSaleCnt !== undefined) {
        product.saleCnt = productSaleCnt
        product.saleTotalCnt = productSaleTotalCnt
      }
    }
    return [...products, ...comps].sort((a, b) => sortMap[a.no] - sortMap[b.no])
  }

  /** 餐品是否能打包map */
  get noToIsCanPackMap () {
    const noToIsCanPackMap: {
      [no: string]: boolean;
    } = {}
    this.products.forEach(product => {
      if (product.type === 'product') {
        noToIsCanPackMap[product.no] = product.isCanTogo
      }
    })
    return noToIsCanPackMap
  }

  /** 餐品no(是否能单独售卖)的索引 */
  get noToIsSingleSaleViewProductMap () {
    return keyBy(this.viewProducts.filter((product: any) => product.isSingleSale), 'no') as {
      [no: string]: IViewProduct;
    }
  }

  /** 餐品no(是否能单独售卖(套餐内餐品))的索引 */
  get noToIsNotSingleInComboViewProductMap () {
    return keyBy(this.viewProducts.filter((product: any) => product.isNotSingleInCombo), 'no') as {
      [no: string]: IViewProduct;
    }
  }

  /** 餐品no(是否在餐单中显示)的索引 */
  get noToIsShowInMenuViewProductMap () {
    return keyBy(this.viewProducts.filter((product: any) => product.isShowInMenu), 'no') as {
      [no: string]: IViewProduct;
    }
  }

  /** 餐品no的索引 */
  get noToViewProductMap () {
    return keyBy(this.viewProducts, 'no') as {
      [no: string]: IViewProduct;
    }
  }

  /** 分类no的索引 */
  get categoryNoToCategoryMap () {
    return keyBy(this.categories, 'no') as {
      [categoryNo: string]: ICategory;
    }
  }

  /** 显示分类No对应的餐品 */
  get categoryNoToViewProductsMap () {
    const categroyMap: { [categoryNo: string]: IViewProduct[] } = {}
    this.viewProducts.forEach(viewProduct => {
      viewProduct.categories.forEach(categoryNo => {
        if (categroyMap[categoryNo]) {
          categroyMap[categoryNo].push(viewProduct)
        } else {
          categroyMap[categoryNo] = [viewProduct]
        }
      })
    })
    return categroyMap
  }

  /** 加料项no的索引 */
  get modifierNoToModifierMap () {
    const modifiers = flattenDeep(map(this.products, item => map(item?.modifierGroups || [], 'modifiers')))
    return keyBy(modifiers, 'no') as {
      [no: string]: IModifier;
    }
  }

  /** 初始化置入餐品数据 */
  init ({ product = [], category = [] }, channel?: TChannel) {
    this.products = (restaurantConfig.hideOpenPriceProduct ? product.filter((product: any) => !product.isOpenPrice) : product) as any
    this.categories = category as any
    this.isInited = true
    this.setChannel(channel)
  }

  // 修改channel
  setChannel (channel?: TChannel) {
    this.channel = channel || (restaurantConfig.app !== 'mini' ? restaurantConfig.app : 'mobile')
    restaurantCenter.emit(RESTAURANT_EVENT.ORDER_CHANNEL_CHANGED, { channel: this.channel })
  }

  /** 重置餐品数据 */
  reset () {
    this.products = []
    this.categories = []
  }
}

export default new Product()
